import { render, staticRenderFns } from "./PlayerInfoDialog.vue?vue&type=template&id=67537890&"
import script from "./PlayerInfoDialog.vue?vue&type=script&lang=js&"
export * from "./PlayerInfoDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports